const map = {
	"./2021-02-12-welcome-to-the-new-ocl.md": [
		2847,
		[
			2847
		]
	],
	"./2021-12-07-get-started-with-ocl-terminology-management-the-ocl-technical-showcase-from-ohie21.md": [
		583,
		[
			583
		]
	],
	"./2022-02-25-ocl-api-the-basics-getting-started-and-api-parameters-a-walk-through-video-series.md": [
		182,
		[
			182
		]
	],
	"./2022-03-14-upcoming-event-ocl-office-hours-on-march-24.md": [
		3725,
		[
			3725
		]
	],
	"./2022-03-28-driven-by-real-needs-the-openmrs-dictionary-manager-web-app.md": [
		4794,
		[
			4794
		]
	],
	"./2022-04-12-designing-for-you.md": [
		8154,
		[
			8154
		]
	],
	"./2022-10-03-the-basics-of-collection-management-in-ocl-new-playlist.md": [
		352,
		[
			352
		]
	],
	"./2022-10-19-ciel-bridging-terminology-for-the-global-community.md": [
		4196,
		[
			4196
		]
	],
	"./2022-10-27-upcoming-event-ocl-office-hours-on-november-3.md": [
		3777,
		[
			3777
		]
	],
	"./2023-02-07-2023-ocl-community-roadmap.md": [
		2812,
		[
			2812
		]
	],
	"./2023-03-01-deprecating-the-openmrs-dictionary-manager.md": [
		2834,
		[
			2834
		]
	],
	"./2023-03-13-using-ocl-for-openmrs-concept-dictionary-management.md": [
		6063,
		[
			6063
		]
	],
	"./2023-03-22-ocl-fhir-core-beta.md": [
		6054,
		[
			6054
		]
	],
	"./2023-04-14-terminology-management-is-getting-smarter.md": [
		143,
		[
			143
		]
	],
	"./2023-07-06-upcoming-event-ocl-quarterly-showcase-wednesday-12-july.md": [
		1057,
		[
			1057
		]
	],
	"./2023-07-14-in-case-you-missed-it-july-2023-ocl-quarterly-showcase.md": [
		8906,
		[
			8906
		]
	],
	"./2023-08-04-coming-in-2024-oclv3-the-first-step-towards-smart-dictionaries.md": [
		8804,
		[
			8804
		]
	],
	"./2023-08-15-whats-the-latest-with-national-health-data-dictionaries-nhdds.md": [
		326,
		[
			326
		]
	],
	"./2023-08-23-ocl-search-improvements-enhancing-precision-and-user-experience.md": [
		2744,
		[
			2744
		]
	],
	"./2023-10-04-upcoming-event-ocl-quarterly-showcase-wednesday-11-october.md": [
		7596,
		[
			7596
		]
	],
	"./2023-11-30-ocl-at-helina-2023.md": [
		5009,
		[
			5009
		]
	],
	"./2024-01-22-upcoming-event-ocl-quarterly-showcase-wednesday-24-january.md": [
		1659,
		[
			1659
		]
	],
	"./2024-01-23-celebrating-2023-and-a-sneak-preview-of-ocls-2024-year-of-community.md": [
		1740,
		[
			1740
		]
	],
	"./2024-02-09-in-case-you-missed-it-january-2024-ocl-quarterly-showcase.md": [
		4119,
		[
			4119
		]
	],
	"./2024-02-12-ocl-selected-for-amazon-web-services-aws-health-equity-initiative.md": [
		5695,
		[
			5695
		]
	],
	"./2024-02-15-2024-ocl-community-roadmap.md": [
		5275,
		[
			5275
		]
	],
	"./2024-07-02-announcing-the-2024-ocl-fellowship.md": [
		2258,
		[
			2258
		]
	],
	"./2024-07-09-upcoming-event-ocl-quarterly-showcase-wednesday-17-july.md": [
		200,
		[
			200
		]
	],
	"./2024-08-01-nhdd-conceptual-framework-nhdd-use-cases.md": [
		2773,
		[
			2773
		]
	],
	"./2024-09-24-upcoming-event-ocl-quarterly-showcase-wednesday-9-october.md": [
		1000,
		[
			1000
		]
	],
	"./2024-10-16-insights-and-future-directions-from-the-ocl-community-survey.md": [
		8586,
		[
			8586
		]
	],
	"./2024-10-23-ocl-puts-its-fhir-core-to-the-test-at-the-hl7-connectathon.md": [
		6495,
		[
			6495
		]
	],
	"./2025-02-04-2025-ocl-community-roadmap.md": [
		5615,
		[
			5615
		]
	],
	"./2025-02-24-ocl-is-a-digital-public-good.md": [
		2930,
		[
			2930
		]
	],
	"./2025-04-29-introducing-ocl-squads.md": [
		8728,
		[
			8728
		]
	],
	"./2026-02-05-first-year-building-the-bridge-between-clinical-practice-software-and-terminologies-openmrs-ocl-ciel.md": [
		1856,
		[
			1856
		]
	],
	"./2026-02-17-a-new-model-for-terminology-services-ocl-and-hl7-brasil-announce-partnership.md": [
		3826,
		[
			3826
		]
	],
	"./2026-06-09-scispacy-loinc-parvati-jamia.md": [
		7536,
		[
			7536
		]
	],
	"./2026-09-28-letter-to-the-ocl-community.md": [
		8367,
		[
			8367
		]
	],
	"./2026-10-05-ciel-managed-entirely-in-ocl.md": [
		3374,
		[
			3374
		]
	],
	"./2026-11-01-ocl-online-pro-is-open.md": [
		6866,
		[
			6866
		]
	],
	"./TEMPLATE.md": [
		7448,
		[
			7448
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6856;
module.exports = webpackAsyncContext;